export const MODAL_NOTIFICATION_ALIAS = {
  CALENDAR_EVENT: "CALENDAR_EVENT",
  CLIENT_STATEMENT: "CLIENT_STATEMENT",
}
